export default __webpack_public_path__ + "static/media/matriz.cd2e19e9.png";